export default __webpack_public_path__ + "static/media/Cargo4.11750abe.png";